import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsTags } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';

import { useAssignTags, useCreateTag } from '../../../models/tags/mutations';
import TagMultiSelect from '../TagMultiSelect/TagMultiSelect';

const BulkAssignTagsModal = ({ isOpen, onClose, scope, targetLabel, allTags = [], onSuccess }) => {
	const [selected, setSelected] = useState([]);
	const assignTags = useAssignTags();
	const createTag = useCreateTag();

	const handleCreateTag = async (name) => {
		const { tag } = await createTag.mutateAsync({ name });
		return tag;
	};

	const handleSubmit = () => {
		if (selected.length === 0) return;
		assignTags.mutate(
			{ ...scope, tagIds: selected.map((t) => t.id) },
			{
				onSuccess: () => {
					onSuccess?.();
					onClose();
				},
			},
		);
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="m">
			<Panel.Header
				icon={BsTags}
				onClose={onClose}
				subtitle="Die ausgewählten Tags werden zu den Unternehmen hinzugefügt. Vorhandene Tags bleiben erhalten."
			>
				Tags für {targetLabel}
			</Panel.Header>
			<Panel.Body>
				<TagMultiSelect
					value={selected}
					allTags={allTags}
					onChange={setSelected}
					onCreateTag={handleCreateTag}
					placeholder="Tag auswählen oder erstellen …"
				/>
			</Panel.Body>
			<Panel.Footer className="justify-end">
				<Button type="button" variant="outline" size="sm" onClick={onClose}>
					Abbrechen
				</Button>
				<Button
					type="button"
					variant="solid"
					size="sm"
					onClick={handleSubmit}
					loading={assignTags.isPending}
					disabled={selected.length === 0}
				>
					Zuweisen
				</Button>
			</Panel.Footer>
		</Modal>
	);
};

BulkAssignTagsModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	/** Request scope from useScopedSelection's toActionScope('companyIds'). */
	scope: PropTypes.object.isRequired,
	/** Accusative phrase from describeActionTarget, e.g. "alle 150 gefilterten Unternehmen". */
	targetLabel: PropTypes.string.isRequired,
	allTags: PropTypes.array,
	onSuccess: PropTypes.func,
};

export default BulkAssignTagsModal;
